// extracted by mini-css-extract-plugin
export default {"report":"Report_report__Mhgqf","title":"Report_title__HG52c","email":"Report_email__sqHdq"};